import { useContent } from "@/context/ContentContext";

export const ParaQuien = () => {
  const { para_quien: p } = useContent();

  const Col = ({ label, title, items }) => (
    <div>
      <p className="lb">{label}</p>
      <h3 className="h h3" style={{ margin: "14px 0 24px" }}>{title}</h3>
      <ul className="list">
        {(items || []).map((t, i) => <li key={i}>{t}</li>)}
      </ul>
    </div>
  );

  return (
    <section className="sec bl" id="para-quien" data-testid="para-quien">
      <div className="wrap">
        <p className="lb">{p?.label}</p>
        <h2 className="h h2" style={{ marginTop: 20, maxWidth: 1300 }}>
          {p?.title} <span className="ac">{p?.title_accent}</span>
        </h2>
        <div className="split" style={{ marginTop: "clamp(48px,6vw,88px)" }}>
          <Col label={p?.marca_label} title={p?.marca_title} items={p?.marca_items} />
          <Col label={p?.proyecto_label} title={p?.proyecto_title} items={p?.proyecto_items} />
        </div>
      </div>
    </section>
  );
};
